<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#item_scores" aria-selected="false">
                                {{ $t('customers_club.setting.item_scores') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#min_level_score" aria-selected="false">
                                {{ $t('customers_club.setting.min_level_score') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#payment_helper_wage_plan"
                               aria-selected="false">
                                {{ $t('customers_club.setting.wage_plan') }}
                                {{ $t('customers_club.setting.payment_helper') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#ivr_wage_plan" aria-selected="false">
                                {{ $t('customers_club.setting.wage_plan') }} {{ $t('customers_club.setting.ivr') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#pardakht_shakhsi_wage_plan"
                               aria-selected="false">
                                {{ $t('customers_club.setting.wage_plan') }}
                                {{ $t('customers_club.setting.pardakht_shakhsi') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <form id="customers-club-settings-form">
                    <div class="tab-content">
                        <div class="tab-pane active" id="item_scores">
                            <item-scores :customers_club_setting="customers_club_setting"></item-scores>
                        </div>
                        <div class="tab-pane" id="min_level_score">
                            <min-score-level :customers_club_setting="customers_club_setting"></min-score-level>
                        </div>
                        <div class="tab-pane" id="payment_helper_wage_plan">
                            <PaymentHelperWagePlan
                                    :customers_club_setting="customers_club_setting"></PaymentHelperWagePlan>
                        </div>
                        <div class="tab-pane" id="ivr_wage_plan">
                            <IvrWagePlan :customers_club_setting="customers_club_setting"></IvrWagePlan>
                        </div>
                        <div class="tab-pane" id="pardakht_shakhsi_wage_plan">
                            <PardakhtShakhsiWagePlan
                                    :customers_club_setting="customers_club_setting"></PardakhtShakhsiWagePlan>
                        </div>
                        <kt-form-action class="mt-4" v-if="$can('change-setting', 'customer-club')">
                            <kt-button
                                    variant="success"
                                    type="submit"
                                    @click="submit"
                                    id="customers_club_setting_btn"
                            >
                                {{ $t('customers_club.register') }}
                            </kt-button>
                        </kt-form-action>
                    </div>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import $ from 'jquery'
import {mapGetters} from "vuex"
import {KTApp} from '@/plugins/core/app'
import {KTUtil} from '@/plugins/core/util'
import {customersClubService} from "@/common/api.service";
import {
    ItemScores,
    PardakhtShakhsiWagePlan,
    IvrWagePlan,
    PaymentHelperWagePlan,
    MinScoreLevel
} from "@/views/customersClub/index";

export default {
    components: {
        'main-content': mainContent,
        PardakhtShakhsiWagePlan,
        IvrWagePlan,
        PaymentHelperWagePlan,
        'min-score-level': MinScoreLevel,
        'item-scores': ItemScores,
    },
    computed: {
        ...mapGetters('customersClub', [
            'customers_club_setting', 'status',
        ])
    },
    mounted() {
        this.$store.dispatch('customersClub/fetchSetting')
    },
    methods: {
        submit(e) {
            let form = $('#customers-club-settings-form')
            let btn = $('#customers_club_setting_btn')
            KTApp.progress(btn)
            let params = structuredClone(this.customers_club_setting);
            delete params.payment_helper;
            delete params.pardakht_shakhsi;
            delete params.ivr;

            customersClubService.set({
                ...params,
                ...this.customers_club_setting.payment_helper,
                ...this.customers_club_setting.pardakht_shakhsi,
                ...this.customers_club_setting.ivr,
            })
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                    })

        },
    }
}
</script>

<style>
@media (min-width: 768px) {
    #tool_setting > div > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>